import { useSelector } from 'react-redux';

import { selectUser } from '@app/redux';

import { ProductInstanceStatus } from '@mfe/shared/schema-types';

export const useCanPlaceOrders = () => {
  const {
    user: { isSoftSuspended, productInstanceStatus },
  } = useSelector(selectUser);

  const isSuspended = productInstanceStatus === ProductInstanceStatus.Suspended || isSoftSuspended;
  const isDisconnected =
    productInstanceStatus === ProductInstanceStatus.Deactivated ||
    productInstanceStatus === ProductInstanceStatus.Canceled;

  const canPlaceOrders = !isSuspended && !isDisconnected;

  return { isSuspended, isDisconnected, canPlaceOrders };
};
